/* 甘寧傳・第 1 章：夏口（建安八年，203）
 * 長江在南邊由東往西流；北岸一條沿江大路，西邊盡頭是黃祖的夏口營。
 * 黃祖的敗軍沿大路往西退，孫權的追兵從東邊來；江邊中段有一處淺灘（ LAND ），追兵的輕舟可以在那裡靠岸截路。 */
export const ROAD = [[8600, 2300], [7000, 2250], [5200, 2350], [3200, 2300], [1800, 2150], [900, 2000]];
export const CAMP = [900, 2000], LAND = [3200, 2640], BOAT0 = [8700, 3080];
export default {
  id: 'ganning_xiakou', name: '夏口', W: 9200, H: 4400, seed: 203,
  bases: [[8200, 2300], CAMP],
  rivers: [{ pts: [[-100, 3380], [3000, 3330], [6000, 3400], [9300, 3340]], hw: 520, fords: [] }],
  roads: [{ pts: ROAD, w: 140 }],
  rocks: [[2400, 900, 420, 200], [5000, 800, 420, 200], [7200, 1000, 400, 200], [4200, 1500, 260, 120]],
  woods: 0.45,
  sight: 0.9,
  clearings: [[CAMP[0], CAMP[1], 600], [LAND[0], LAND[1] - 80, 420], [8200, 2300, 500]],
  marsh: [[LAND[0], LAND[1] + 120, 300, 100]],
  tents: [{ x: CAMP[0], y: CAMP[1] - 60, n: 8, r: 420, chief: true, col: '#3e5a5a', flag: '黃' }],
  grass: [[6100, 2700, 240, 100], [4300, 2700, 220, 90], [2200, 2650, 220, 90]],
};
